
const MemberTestimonialsSection = () => {
  return (
    <section
      className="w-full flex flex-col items-center justify-center px-4 md:px-8 py-16 md:py-24"
      style={{
        backgroundColor: '#F1F1F1'
      }}
    >
      <div className="flex flex-col md:flex-row gap-8 max-w-6xl mx-auto">
        {/* Bag Image */}
        <div className="flex-1 flex justify-center" style={{ padding: 0 }}>
          <img
            src="/Bespoke Shopping/Member Testimonials/bag.png"
            alt="Hermès Kelly Bag"
            className="h-auto object-contain"
            style={{ width: '80%' }}
          />
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col items-center justify-center text-center gap-6 md:gap-8 lg:gap-10">
          {/* Member Testimonials Title */}
          <h2
            className="text-sm md:text-base"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#764F2B',
              fontWeight: '400',
              fontStyle: 'italic'
            }}
          >
            Member Testimonials
          </h2>

          {/* Balloon Icon */}
          <img
            src="/Bespoke Shopping/Member Testimonials/ballon.png"
            alt="Balloon"
            className="w-10 h-10 md:w-12 md:h-12 lg:w-15 lg:h-15"
          />

          {/* The Perfect Birthday Surprise Subtitle */}
          <h3
            className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl"
            style={{
              fontFamily: 'Cardo, serif',
              color: '#000000',
              fontWeight: '400',
              lineHeight: '1.2'
            }}
          >
            The Perfect Birthday Surprise
          </h3>

          {/* Testimonial Text */}
          <p
            className="text-sm md:text-base"
            style={{
              fontFamily: 'Plus Jakarta Sans, sans-serif',
              color: '#7B7B7B',
              lineHeight: '1.6'
            }}
          >
            James wanted an extraordinary birthday surprise for his wife—a piece that would be both rare and meaningful. He turned to his FGA Prestige shopping concierge, who listened closely and began the search for a Hermès Kelly, settling on the elusive "5P Bubblegum Pink" known among collectors for its vibrant, joyful hue and near-mythical rarity.
          </p>
        </div>
      </div>
    </section>
  )
}

export default MemberTestimonialsSection